import React from 'react';
import MapView from './MapView';
import OptimizeRouteButton from './OptimizeRouteButton';
import RouteSummary from './RouteSummary';
import { Customer } from '../types/types';
interface UserViewProps {
  customers: Customer[];
  optimizedRoute: any;
  routeSummary: {
    distance: string;
    duration: string;
  } | null;
  optimizeRoute: () => void;
}
const UserView: React.FC<UserViewProps> = ({
  customers,
  optimizedRoute,
  routeSummary,
  optimizeRoute
}) => {
  const selectedCustomers = customers.filter(customer => customer.selected);
  return <div className="flex flex-col md:flex-row flex-1" data-id="element-144">
      <div className="w-full md:w-1/3 bg-white p-4 overflow-auto shadow-md" data-id="element-145">
        <h1 className="text-2xl font-bold mb-6 text-gray-800" data-id="element-146">Route Viewer</h1>
        <div className="mb-6" data-id="element-147">
          <h2 className="text-lg font-semibold mb-3 text-gray-700" data-id="element-148">
            Selected Customers
          </h2>
          {selectedCustomers.length > 0 ? <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2" data-id="element-149">
              {selectedCustomers.map(customer => <div key={customer.id} className="border border-gray-200 rounded-lg p-3 bg-white" data-id="element-150">
                  <h3 className="font-medium text-gray-800" data-id="element-151">{customer.name}</h3>
                  <p className="text-sm text-gray-600 mt-1 truncate" data-id="element-152">
                    {customer.address}
                  </p>
                </div>)}
            </div> : <div className="text-center py-8 text-gray-500" data-id="element-153">
              No customers selected
            </div>}
        </div>
        <div className="mt-auto" data-id="element-154">
          {routeSummary && <RouteSummary summary={routeSummary} data-id="element-155" />}
          <OptimizeRouteButton optimizeRoute={optimizeRoute} data-id="element-156" />
        </div>
      </div>
      <MapView customers={customers} optimizedRoute={optimizedRoute} data-id="element-157" />
    </div>;
};
export default UserView;